import { render } from "./ReceiptDialog.vue?vue&type=template&id=aae995e4&scoped=true"
import script from "./ReceiptDialog.vue?vue&type=script&lang=js"
export * from "./ReceiptDialog.vue?vue&type=script&lang=js"

import "./ReceiptDialog.vue?vue&type=style&index=0&id=aae995e4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aae995e4"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QBanner,QIcon,QCardSection,QSpace,QBtn,QCardActions});qInstall(script, 'directives', {ClosePopup});
